import { render, staticRenderFns } from "./AdminTagForm.vue?vue&type=template&id=461f4e45"
import script from "./AdminTagForm.vue?vue&type=script&lang=js"
export * from "./AdminTagForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports